module.exports = __webpack_public_path__ + "static/media/ic-cam-list-none.337626d1.svg";